import CTAButton from '../components/CTAButton';
import { FaRobot, FaVrCardboard, FaUsers, FaGamepad, FaBrain, FaCloud } from 'react-icons/fa';
import metaImage from '../Assert/4.png';
import useDocumentTitle from '../hooks/useDocumentTitle';

const introImg = require('../Assert/15.jpg');

function Meta() {
  useDocumentTitle('Meta Applications — MMI');

  return (
    <main className="meta-page">
      {/* Hero Section - Two Column Layout */}
      <section className="meta-hero">
        <div className="container">
          <div className="hero-two-column">
            {/* Left Column - Text */}
            <div className="hero-left">
              <h1 className="hero-title">
                The Next Layer of
                <br />
                <span className="gradient-text">Reality Is Being Built</span>
                <br />
                Right Now.
              </h1>
              <p className="hero-description">
                Merging physical and digital realms through high-fidelity spatial 
                computing and obsidian-grade neural interfaces.
              </p>
            </div>
            {/* Right Column - Image */}
            <div className="hero-right">
              <div className="hero-image-container">
                <img 
                  src={metaImage} 
                  alt="Meta Applications" 
                  className="hero-image-meta"
                />
                <div className="hero-image-glow"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <div className="intro-wrapper">
            <div className="intro-content">
              <p className="intro-text">
                Spatial computing is not science fiction.
              </p>
              <p className="intro-description">
                MMI builds Meta applications of AI and immersive technology environments where 
                intelligent avatars respond, digital twins mirror reality, and virtual places 
                feel like places worth being in. We have been thinking about this longer than most. 
                We are building it now.
              </p>
            </div>
            <div className="intro-media">
              <div className="assert-image-wrap">
                <img src={introImg} alt="Meta applications" className="assert-image" />
                <div className="assert-image-glow" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Grid Section */}
      <section className="features-section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <FaRobot className="feature-icon" />
              </div>
              <h3 className="feature-title">AI-Powered Avatar</h3>
              <p className="feature-description">
                Intelligent digital personas that respond, learn, and represent users in spatial environments.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <FaVrCardboard className="feature-icon" />
              </div>
              <h3 className="feature-title">Spatial Computing</h3>
              <p className="feature-description">
                Mixed-reality systems that blend physical and digital worlds with precise spatial awareness.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <FaUsers className="feature-icon" />
              </div>
              <h3 className="feature-title">Virtual Collaboration Platforms</h3>
              <p className="feature-description">
                Shared virtual workspaces where teams meet, build, and work together in real time.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <FaGamepad className="feature-icon" />
              </div>
              <h3 className="feature-title">Interactive Metaverse Environment</h3>
              <p className="feature-description">
                Persistent virtual worlds for engagement, events, and immersive brand experiences.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <FaBrain className="feature-icon" />
              </div>
              <h3 className="feature-title">Intelligent Virtual Spaces</h3>
              <p className="feature-description">
                Adaptive environments powered by AI that respond to context and user behavior.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-wrapper">
                <FaCloud className="feature-icon" />
              </div>
              <h3 className="feature-title">Digital Twin Systems</h3>
              <p className="feature-description">
                Live digital mirrors of physical assets and operations for monitoring and simulation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Join the Network Section */}
      <section className="join-section">
        <div className="container">
          <div className="cta-box">
            <h2 className="join-title">
              Join the <span className="gradient-text">Network</span>
            </h2>
            <CTAButton text="Book a Call" to="/contact" />
          </div>
        </div>
      </section>

    </main>
  );
}

export default Meta;